import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  margin-bottom: 16px;
  padding: 8px 36px 8px 12px;
  border: 1px solid #ffe58f;
  border-radius: 8px;
  background: #fffbe6;
`;

export const IconWrapper = styled.div`
  font-size: 16px;
  color: #f59e0b;
`;

export const Description = styled.p`
  margin: 0;
  font-size: 14px;
  color: #000000;
`;

export const DismissButton = styled.button`
  position: absolute;
  right: 12px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  color: #00000073;
`;
